/* KHAN reveal-on-scroll — staggered fade-and-rise entrances.
   Add class="khan-reveal" to any element; add "khan-reveal-group"
   to a parent to stagger its children. */
(function () {
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    var observeAll = function () {
      document
        .querySelectorAll('.khan-reveal:not(.is-visible)')
        .forEach(function (el) {
          io.observe(el);
        });
    };

    // Auto-tag common theme blocks for reveal
    var autoTags = [
      '.collection-list .card',
      '.featured-collection .card',
      '.image-with-text__content > *',
      '.rich-text__blocks > *',
      '.multicolumn-card',
      '.footer-block',
    ];
    var tagAuto = function () {
      autoTags.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.classList.contains('khan-reveal')) {
            el.classList.add('khan-reveal');
          }
        });
      });
      // group parents for stagger
      document
        .querySelectorAll(
          '.collection-list__list, .featured-collection .slider, .multicolumn-list, .rich-text__blocks'
        )
        .forEach(function (el) {
          el.classList.add('khan-reveal-group');
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        tagAuto();
        observeAll();
      });
    } else {
      tagAuto();
      observeAll();
    }
    // Re-scan after AJAX (filters, predictive search)
    document.addEventListener('shopify:section:load', function () {
      tagAuto();
      observeAll();
    });
  } else {
    document.querySelectorAll('.khan-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
})();
